// 商品相关全部请求
import environment from '../../config/environment'
import {getProductListAPI} from '../api'
import {encrypt} from '../common'
import qs from 'qs'

// 常量
const API_CODE = environment.apiCode
const API_KEY = environment.apiKey

// 企业列表查询
function getProductList (paramObj, token) {
    // json转string
    const paramStr = JSON.stringify(paramObj)
    // 变密
    const params = qs.stringify({
        code: API_CODE,
        token: token,
        param: encrypt(paramStr, API_CODE, API_KEY)
    })
    return getProductListAPI(params)
}

export {getProductList}



// WEBPACK FOOTER //
// ./src/request/index/product.js